import React, { useState, useEffect } from "react"
import { TransitionGroup, Transition } from "react-transition-group"
import { LazyImage } from "ui"
import { useQuery } from "lib"

const bgQuery = {
    collection: "site",
    query: {
        type: "bg",
    },
}
const bgConfig = { setEntityInfo: true, single: true }
const INTERVAL = 60000

const useBg = () => {
    const [index, setIndex] = useState(0)
    const [entity] = useQuery(bgQuery, bgConfig)

    useEffect(() => {
        const tick = () => {
            if (!entity || !entity.bg || entity.bg.length === 0) return
            setIndex(index => {
                /* eslint no-constant-condition: ["error", { "checkLoops": false }]*/
                while (true) {
                    const i = Math.floor(Math.random() * entity.bg.length)
                    if (i !== index) return i
                }
            })
        }
        let intv = INTERVAL
        if (entity) {
            try {
                intv = parseInt(entity.interval, 10) * 1000
            } catch (err) {
                console.log(err)
            }
        }
        const id = setInterval(tick, intv)
        return () => {
            clearInterval(id)
        }
    }, [entity])

    if (!entity || !entity.bg || entity.bg.length === 0 || !entity.bg[index]) return [null, -1]
    return [entity.bg[index], index]
}

const Bg = () => {
    const [bg, i] = useBg()
    return (
        <TransitionGroup id="site-bg" appear={true} enter={true}>
            <Transition key={i} unmountOnExit={true} timeout={1500}>
                {status => <LazyImage className={status} src={bg} bg />}
            </Transition>
        </TransitionGroup>
    )
}

export default React.memo(Bg)
